/* « Filtrer et trier » façon Loban (lot 4 — docs/superpowers/specs/2026-10-03-moola-facon-loban.md, § 4.7).
   - Sous 1000 px : le bouton FLOTTANT ouvre la feuille du bas par window.MoolaTiroir (dialogue modal, focus piégé, Échap,
     croix, voile, « Voir n produits », verrou du défilement, bandeaux cookies masqués, focus rendu au bouton). Le bouton
     s'efface quand le pied de page entre à l'écran, et remonte au-dessus du bandeau cookies quand celui-ci est affiché
     (variable --moola-cookies-h, publiée par moola-entete.js) : il n'est jamais recouvert et ne recouvre jamais la dernière rangée (réserve en CSS).
   - À partir de 1000 px : le même panneau devient la colonne latérale (jamais caché, jamais inerte, groupes dépliés).
   - Tri en popover (≥ 1000 px) : <details> natif ; Échap et le clic extérieur le referment.
   Le script est appelé par le gabarit, donc AVANT moola-tiroir-base.js : il attend DOMContentLoaded. */
document.addEventListener('DOMContentLoaded', function () {
  var f = document.querySelector('[data-moola-filtre]');
  if (!f) { return; }
  var panneau = f.querySelector('.moola-filtre__panneau');
  var voile = f.querySelector('.moola-filtre__voile');
  var bouton = f.querySelector('.moola-filtre__flottant');
  var tiroir = window.MoolaTiroir;
  var large = window.matchMedia('(min-width: 1000px)');
  var DUREE = 420;
  var inerte = function (oui) { if ('inert' in panneau) { panneau.inert = oui; } else if (oui) { panneau.setAttribute('inert', ''); } else { panneau.removeAttribute('inert'); } };

  // Colonne (≥ 1000) ou feuille (< 1000) selon la largeur courante.
  function mode() {
    if (large.matches) {
      if (tiroir && tiroir.ouvert(panneau)) { tiroir.fermer(panneau, true); }
      clearTimeout(panneau._moolaTiroirMinuteur);
      panneau.hidden = false; inerte(false); voile.hidden = true;
      panneau.removeAttribute('role'); panneau.removeAttribute('aria-modal'); panneau.removeAttribute('data-tiroir');
      [].forEach.call(panneau.querySelectorAll('.moola-filtre__groupe:not(.moola-filtre__groupe--tri)'), function (d) { d.open = true; });
    } else if (!tiroir || !tiroir.ouvert(panneau)) {
      panneau.hidden = true; inerte(true);
    }
  }
  if (large.addEventListener) { large.addEventListener('change', mode); } else if (large.addListener) { large.addListener(mode); }

  if (bouton && tiroir) {
    bouton.addEventListener('click', function () {
      tiroir.ouvrir(panneau, { declencheur: bouton, voile: voile, duree: DUREE, focus: '.moola-filtre__fermer' });
    });
  }

  // Le bouton flottant s'efface dès que le pied de page entre à l'écran.
  var pied = document.querySelector('footer');
  if (bouton && pied && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entrees) { bouton.classList.toggle('est-cache', entrees[0].isIntersecting); }).observe(pied);
  }

  // Hauteur du bandeau cookies (--moola-cookies-h) : publiée par moola-entete.js, sur toutes les pages (lot 6).

  // Popover de tri (ordinateur).
  var tri = f.querySelector('.moola-tri');
  if (tri) {
    var s = tri.querySelector('summary');
    s.setAttribute('aria-expanded', 'false');
    tri.addEventListener('toggle', function () { s.setAttribute('aria-expanded', String(tri.open)); });
    document.addEventListener('click', function (e) { if (tri.open && !tri.contains(e.target)) { tri.open = false; } });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && tri.open) { tri.open = false; s.focus(); } });
  }

  mode();
});
